export default "__VITE_ASSET__JtaH1UiW__"